import CaretDown from "@guestsupply/XDL/Icons/CaretDown";
import { xBaseTheme } from "@guestsupply/XDL/types";
import { color } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";

import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        iconProps: {
            src: CaretDown,
            size: 13,
            color: "primary",
            css: css`
                &&& {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 14px;
                    width: auto;
                    top: 4px;
                }
                svg {
                    width: 9px;
                    height: 13px;
                }
            `,
        },
    },
} as xBaseTheme["select"];
